<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >

      </b-col>
      <b-col
        cols="12"
        sm="12"
        class="kothon-bulk-actions d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-button 
          v-if="userDetails && userDetails.interested_on === 'corporate'" 
          variant="info"
          size="sm"
          class="kothon-bulk-action-btn d-inline-flex align-items-center justify-content-center" 
          @click="openBulkModal"
        >
          <feather-icon icon="UploadIcon" size="14" class="mr-50" />
          Bulk Onboard
        </b-button>
        <b-button
          v-if="userDetails && userDetails.interested_on === 'corporate'"
          variant="primary"
          size="sm"
          class="kothon-bulk-action-btn d-inline-flex align-items-center justify-content-center"
          @click="openBulkSelectionModal"
        >
          <feather-icon icon="UploadIcon" size="14" class="mr-50" />
          Bulk Recharge Upload
        </b-button>
        <b-button 
          v-if="userDetails && userDetails.interested_on === 'corporate'" 
          variant="warning"
          size="sm"
          class="kothon-bulk-action-btn d-inline-flex align-items-center justify-content-center" 
          @click="openBulkRechargeModal"
        >
          <feather-icon icon="ZapIcon" size="14" class="mr-50" />
          Bulk Recharge
        </b-button>
        <b-button 
          v-if="userDetails && userDetails.interested_on === 'corporate'" 
          variant="success"
          size="sm"
          class="kothon-bulk-action-btn d-inline-flex align-items-center justify-content-center" 
          @click="openDownloadSummaryModal"
        >
          <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
          Download Summary Excel
        </b-button>
      </b-col>
    </b-row>

    <!-- Kothon Information -->
    <b-card class="mb-2">
      <div class="d-flex align-items-center justify-content-between mb-1 flex-wrap" style="gap: 0.5rem;">
        <div class="d-flex align-items-center flex-wrap" style="gap: 0.5rem;">
          <span class="text-muted" style="font-size: 13px;">Per Page</span>
          <b-form-select
            v-model="didLimit"
            :options="didLimitOptions"
            size="sm"
            class="did-limit-select"
            @change="onDidLimitChange"
          />
          <span class="text-muted" style="font-size: 13px;">
            {{ didTotalCount }} DID number(s)
          </span>
        </div>
        <b-form-input
          v-model="didSearchQuery"
          placeholder="Search by mobile or SIP number..."
          size="sm"
          class="did-search-input"
          @input="onDidSearchInput"
        />
      </div>
      <b-table
        responsive
        :items="kothonInfo"
        :fields="infoFields"
        sticky-header="500px"
        show-empty
        empty-text="No Kothon information found"
        ref="kothonTable"
      >
        <template #cell(select)="data">
          <b-form-checkbox
            :checked="isSelected(data.item.id)"
            @change="toggleSelection(data.item.id)"
          />
        </template>

        <template #cell(sl)="data">
          {{ isDidShowAll ? data.index + 1 : (didOffset) + data.index + 1 }}
        </template>

        <template #cell(balance)="data">
          {{ data.item.balance != null ? data.item.balance : '-' }}
        </template>

        <template #cell(created)="data">
          {{ data.item.created | formatLocalDateTime }}
        </template>

        <template #head(select)>
          <b-form-checkbox
            :checked="isAllSelected"
            @change="toggleSelectAll"
          />
        </template>

        <template #cell(action)="data">
            <b-dropdown
              variant="primary" toggle-class="text-nowrap d-inline-flex align-items-center" right
              size="sm"
            >
              <template #button-content>
                <feather-icon icon="MoreHorizontalIcon" size="14" class="mr-50" />
                Dropdown
              </template>
              <b-dropdown-item @click="rechargeNow(data.item)">
                <feather-icon icon="ZapIcon" size="14" class="mr-50" />
                Recharge
              </b-dropdown-item>
              <b-dropdown-item @click="getBalance(data.item.mobile_number)">
                <feather-icon icon="DollarSignIcon" size="14" class="mr-50" />
               Balance
              </b-dropdown-item>
              <b-dropdown-item @click="setLimitMethod(data.item)">
                <feather-icon icon="SlidersIcon" size="14" class="mr-50" />
               Set Limit
              </b-dropdown-item>
              <b-dropdown-item @click="openLimitSetHistory(data.item)">
                <feather-icon icon="ClockIcon" size="14" class="mr-50" />
                Limit Set History
              </b-dropdown-item>
              <b-dropdown-item @click="setTransactionMethod(data)">
                <feather-icon icon="ListIcon" size="14" class="mr-50" />
              Transction
              </b-dropdown-item>
              <b-dropdown-item @click="setKothonCallHistory(data)">
                <feather-icon icon="PhoneIcon" size="14" class="mr-50" />
              Call History
              </b-dropdown-item>
            </b-dropdown>
        </template>
      </b-table>
      <b-row class="mt-2" v-if="!isDidShowAll && didTotalCount > Number(didLimit)">
        <b-col cols="12" class="d-flex justify-content-center">
          <b-pagination
            v-model="didPage"
            :total-rows="didTotalCount"
            :per-page="didLimit"
            align="center"
            first-number
            last-number
            @input="onDidPageChange"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <!-- Kothon Transactions -->
    <b-card title="Transactions">
      <b-table
        responsive
        :items="paginatedTransactions"
        :fields="transactionFields"
        show-empty
        empty-text="No transaction history found"
      >
        <template #cell(sl)="data">
          {{ (currentPage - 1) * perPage + data.index + 1 }}
        </template>

        <!-- NEW: Fix blank username by falling back to fromname -->
        <template #cell(username)="data">
          {{ data.item.username || data.item.fromname }}
        </template>

        <template #cell(cost)="data"> {{ data.item.cost }} Tk </template>

        <template #cell(creationdate)="data">
          {{ data.item.creationdate | formatLocalDateTime }}
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="12" class="d-flex justify-content-center">
          <b-pagination
            v-model="currentPage"
            :total-rows="transactions.length"
            :per-page="perPage"
            align="center"
            first-number
            last-number
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <div class="row">
      <div class="col-12 col-lg-6">
        <b-card>
          <div class="md">
            <h3 class="mt-10">How to Pay for MiME Internet from Selfcare</h3>
            <video class="responsive-video" width="100%" controls>
              <source :src="videoUrl" type="video/mp4" />
            </video>
          </div>
        </b-card>
      </div>
    </div>

     <!-- Set Limit-->
    <b-modal
      id="setLimitModal"
      :title="'Set Limit (' + currentMobileNumber + ')'"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
    <validation-observer ref="formSetLimitRules">
        <b-form @submit.prevent="submitSetLimit">
          <b-form-group label="Enter a Positive Integer Limit">
            <validation-provider #default="{ errors }" name="limit" rules="required">
              <b-form-input
                type="number"
                v-model="setLimitData.limit"
                placeholder="Set Limit"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <span class="text-danger text-sm" v-if="be_errors['limit']">
              <small>{{ be_errors["limit"][0] }}</small>
            </span>
          </b-form-group>

          <b-button variant="success" type="submit" class="mr-2 d-inline-flex align-items-center">
            <feather-icon icon="CheckIcon" size="14" class="mr-50" />
            Submit
          </b-button>
          <b-button variant="secondary" class="d-inline-flex align-items-center" @click="$bvModal.hide('setLimitModal')">
            <feather-icon icon="XIcon" size="14" class="mr-50" />
            Cancel
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>
    <!-- Recharge Modal -->
    <!-- Single Recharge Modal -->
    <b-modal
      id="rechargeModal"
      :title="'Transfer Balance (' + currentMobileNumber + ')'"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <validation-observer ref="formBalanceRules">
        <b-form @submit.prevent="submitPayment">
          <b-form-group label="Amount">
            <validation-provider #default="{ errors }" name="Amount" rules="required|min_value:1">
              <b-form-input
                type="number"
                v-model="paymentData.credit"
                placeholder="Enter amount"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <span class="text-danger text-sm" v-if="be_errors['credit']">
              <small>{{ be_errors["credit"][0] }}</small>
            </span>
          </b-form-group>

          <b-button variant="success" type="submit" class="mr-2 d-inline-flex align-items-center">
            <feather-icon icon="CheckIcon" size="14" class="mr-50" />
            Submit
          </b-button>
          <b-button variant="secondary" class="d-inline-flex align-items-center" @click="$bvModal.hide('rechargeModal')">
            <feather-icon icon="XIcon" size="14" class="mr-50" />
            Cancel
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Bulk Recharge Modal-->
    <b-modal
      id="bulkRechargeModal"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      body-class="p-0"
      content-class="bulk-modal-content"
    >
      <div class="bulk-modal-wrapper">
  
        <!-- Header -->
        <div class="bm-header">
          <div class="bm-header-left">
            <div class="bm-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="2" y="4" width="12" height="9" rx="1.5" stroke="#185FA5" stroke-width="1.2"/>
                <path d="M5 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1" stroke="#185FA5" stroke-width="1.2"/>
                <circle cx="8" cy="8.5" r="1.5" fill="#185FA5"/>
              </svg>
            </div>
            <div>
              <p class="bm-title">Bulk Recharge</p>
              <p class="bm-subtitle">
                {{ bulkRechargeProgressing ? 'Processing recharge…' : 'Review and confirm all lines' }}
              </p>
            </div>
          </div>
          <button
            class="bm-close-btn"
            :disabled="bulkRechargeProgressing"
            @click="closeBulkRechargeModal"
          >&#x2715;</button>
        </div>
  
        <!-- Body -->
        <div class="bm-body">

          <!-- Progress State -->
          <div v-if="bulkRechargeProgressing" class="bm-progress">
            <p class="bm-progress-label">
              Recharging lines…
              <span v-if="bulkRechargeTotalCount">
                {{ bulkRechargeCompletedCount }} / {{ bulkRechargeTotalCount }}
              </span>
            </p>
            <b-progress
              :value="bulkRechargeProgress"
              :max="100"
              height="1.25rem"
              animated
              show-progress
              variant="primary"
              class="bm-progress-bar"
            ></b-progress>
            <p class="bm-progress-hint">Please wait while the recharge completes. Do not close this window.</p>
          </div>
  
          <div v-else-if="bulkRechargePreview.length">
            <!-- Toolbar -->
            <div class="d-flex align-items-center justify-content-between mb-1 flex-wrap" style="gap: 0.5rem;">
              <div class="d-flex align-items-center" style="gap: 0.5rem;">
                <b-form-select
                  v-model="bulkPreviewLimit"
                  :options="bulkPreviewLimitOptions"
                  size="sm"
                  class="did-limit-select"
                  @change="onBulkPreviewLimitChange"
                />
                <span class="text-muted" style="font-size: 13px;">
                  {{ bulkPreviewTotalCount }} line(s)
                </span>
              </div>
            </div>

            <!-- Table -->
            <div class="bm-table-wrapper">
              <table class="bm-table">
                <thead>
                  <tr>
                    <th class="text-left">Number</th>
                    <th class="text-right">Limit</th>
                    <!-- <th class="text-right">Last usage</th> -->
                    <th class="text-right">Current Month Recharged</th>
                    <th class="text-right">Balance</th>
                    <th class="text-right">Amount to Recharge</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in bulkRechargePreview" :key="index">
                    <td class="bm-mono">{{ item.mobile_number }}</td>
                    <td class="text-right bm-muted">{{ item.limit }}</td>
                    <!-- <td class="text-right bm-muted">{{ item.last_usage }}</td> -->
                    <td class="text-right bm-muted">{{ item.current_month_recharged }}</td>
                    <td class="text-right bm-muted">{{ item.balance }}</td>
                    <td class="text-right bm-amount">{{ item.amount_to_recharge }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" class="bm-total-label">Total</td>
                    <td class="text-right bm-total-value">{{ bulkRechargeTotal }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- Pagination -->
            <div class="d-flex justify-content-center mt-2" v-if="bulkPreviewTotalCount > bulkPreviewLimit">
              <b-pagination
                v-model="bulkPreviewPage"
                :total-rows="bulkPreviewTotalCount"
                :per-page="bulkPreviewLimit"
                align="center"
                first-number
                last-number
                @input="onBulkPreviewPageChange"
              ></b-pagination>
            </div>
  
            <!-- Warning Banner -->
            <div class="bm-warning">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="bm-warning-icon">
                <circle cx="8" cy="8" r="6.5" stroke="#92640A" stroke-width="1.2"/>
                <path d="M8 5v3.5" stroke="#92640A" stroke-width="1.2" stroke-linecap="round"/>
                <circle cx="8" cy="11" r="0.7" fill="#92640A"/>
              </svg>
              <p class="bm-warning-text">
                This will recharge <strong>{{ bulkRechargeTotal }}</strong> across
                {{ bulkPreviewTotalCount }} selected lines. This action cannot be undone.
              </p>
            </div>
  
          </div>
  
          <!-- Loading State -->
          <div v-else class="bm-loading">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
            <p class="bm-loading-text">Loading preview data...</p>
          </div>
  
        </div>
  
        <!-- Footer -->
        <div v-if="!bulkRechargeProgressing" class="bm-footer">
          <button
            class="bm-btn bm-btn-cancel d-inline-flex align-items-center"
            @click="closeBulkRechargeModal"
          >
            <feather-icon icon="XIcon" size="14" class="mr-50" />
            Cancel
          </button>
          <button
            class="bm-btn bm-btn-confirm d-inline-flex align-items-center"
            :disabled="!bulkRechargePreview.length || bulkRechargeSubmitting"
            @click="submitBulkRecharge"
          >
            <b-spinner small v-if="bulkRechargeSubmitting"></b-spinner>
            <feather-icon v-else icon="CheckIcon" size="14" class="mr-50 text-white" />
            Confirm recharge
          </button>
        </div>
  
      </div>
    </b-modal>

    <!-- Download Summary Modal -->
    <b-modal
      id="downloadSummaryModal"
      size="md"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      body-class="p-0"
      content-class="ds-modal-content"
    >
      <div class="ds-wrapper">
  
        <!-- Header -->
        <div class="ds-header">
          <div class="ds-header-left">
            <div class="ds-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 2v8M5 7l3 3 3-3" stroke="#0F6E56" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 12h10" stroke="#0F6E56" stroke-width="1.3" stroke-linecap="round"/>
              </svg>
            </div>
            <div>
              <p class="ds-title">Download Summary</p>
              <p class="ds-subtitle">Export data as Excel spreadsheet</p>
            </div>
          </div>
          <button class="ds-close-btn" @click="$bvModal.hide('downloadSummaryModal')">&#x2715;</button>
        </div>
  
        <!-- Body -->
        <div class="ds-body">
          <validation-observer ref="summaryRules">
            <b-form @submit.prevent="downloadSummary">
  
              <!-- Date Range Row -->
              <div class="ds-date-grid">
                <!-- From Date -->
                <div class="ds-field">
                  <label class="ds-label">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <rect x="1" y="2" width="10" height="9" rx="1.2" stroke="currentColor" stroke-width="1.1"/>
                      <path d="M4 1v2M8 1v2M1 5h10" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/>
                    </svg>
                    From date
                  </label>
                  <validation-provider #default="{ errors }" name="From Date" rules="required">
                    <div :class="['ds-input-wrap', { 'ds-input-error': errors[0] }]">
                      <flat-pickr
                        v-model="summaryFilters.from_date"
                        :config="summaryDateConfig.fromDate"
                        class="ds-input ds-summary-date"
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                    <span class="ds-error" v-if="errors[0]">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                        <circle cx="5.5" cy="5.5" r="4.5" stroke="#A32D2D" stroke-width="1"/>
                        <path d="M5.5 3.5v2.5" stroke="#A32D2D" stroke-width="1" stroke-linecap="round"/>
                        <circle cx="5.5" cy="7.5" r="0.5" fill="#A32D2D"/>
                      </svg>
                      {{ errors[0] }}
                    </span>
                  </validation-provider>
                </div>
  
                <!-- To Date -->
                <div class="ds-field">
                  <label class="ds-label">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <rect x="1" y="2" width="10" height="9" rx="1.2" stroke="currentColor" stroke-width="1.1"/>
                      <path d="M4 1v2M8 1v2M1 5h10" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/>
                    </svg>
                    To date
                  </label>
                  <validation-provider #default="{ errors }" name="To Date" rules="required">
                    <div :class="['ds-input-wrap', { 'ds-input-error': errors[0] }]">
                      <flat-pickr
                        v-model="summaryFilters.to_date"
                        :config="summaryDateConfig.toDate"
                        class="ds-input ds-summary-date"
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                    <span class="ds-error" v-if="errors[0]">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                        <circle cx="5.5" cy="5.5" r="4.5" stroke="#A32D2D" stroke-width="1"/>
                        <path d="M5.5 3.5v2.5" stroke="#A32D2D" stroke-width="1" stroke-linecap="round"/>
                        <circle cx="5.5" cy="7.5" r="0.5" fill="#A32D2D"/>
                      </svg>
                      {{ errors[0] }}
                    </span>
                  </validation-provider>
                </div>
              </div>
  
              <!-- Selected Lines Badge -->
              <div class="ds-lines-badge" v-if="selectedRows.length">
                <div class="ds-lines-left">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <rect x="1" y="1" width="12" height="12" rx="2" stroke="#185FA5" stroke-width="1.1"/>
                    <path d="M4 7h6M4 4.5h6M4 9.5h4" stroke="#185FA5" stroke-width="1.1" stroke-linecap="round"/>
                  </svg>
                  <span class="ds-lines-label">Selected Kothon lines</span>
                </div>
                <span class="ds-lines-count">{{ selectedRows.length }} lines</span>
              </div>
  
              <!-- Export Info -->
              <div class="ds-info">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="ds-info-icon">
                  <circle cx="6.5" cy="6.5" r="5.5" stroke="#185FA5" stroke-width="1"/>
                  <path d="M6.5 5.5v4" stroke="#185FA5" stroke-width="1" stroke-linecap="round"/>
                  <circle cx="6.5" cy="4" r="0.6" fill="#185FA5"/>
                </svg>
                <p class="ds-info-text">The exported file will include all transaction records within the selected date range.</p>
              </div>
  
              <!-- Footer Actions -->
              <div class="ds-actions">
                <button
                  type="button"
                  class="ds-btn ds-btn-cancel d-inline-flex align-items-center"
                  @click="$bvModal.hide('downloadSummaryModal')"
                >
                  <feather-icon icon="XIcon" size="14" class="mr-50" />
                  Cancel
                </button>
                <button
                  type="submit"
                  class="ds-btn ds-btn-download d-inline-flex align-items-center"
                  :disabled="downloading"
                >
                  <b-spinner small v-if="downloading"></b-spinner>
                  <feather-icon v-else icon="DownloadIcon" size="14" class="mr-50 text-white" />
                  Download Excel
                </button>
              </div>
  
            </b-form>
          </validation-observer>
        </div>
  
      </div>
    </b-modal>

    <!-- Bulk Onboard Modal -->
    <b-modal
      id="bulkOnboardModal"
      title="Bulk Onboarding"
      size="md"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-form-group label="Upload Excel File">
        <b-form-file
          v-model="bulkFile"
          accept=".xlsx, .xls"
          placeholder="Choose Excel file..."
        ></b-form-file>
        <small class="form-text text-muted">
          Excel should have columns: mobile_number, sip_number
        </small>
      </b-form-group>

      <div class="bulk-onboard-actions">
        <b-button
          variant="info"
          class="d-inline-flex align-items-center justify-content-center"
          :disabled="!bulkFile"
          @click="uploadBulkOnboard"
        >
          <feather-icon icon="UploadIcon" size="14" class="mr-50" />
          Upload
        </b-button>
        <b-button
          class="btn-sm d-inline-flex align-items-center justify-content-center"
          variant="secondary"
          as="a"
          href="/BulkMobileSelection_Sample.xlsx"
          download
        >
          <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
          Download Sample
        </b-button>
      </div>
    </b-modal>

    <!-- Bulk Selection Modal -->
    <b-modal
      id="bulkSelectionModal"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      header-class="bulk-selection-modal-header"
      @hidden="resetBulkSelectionModal"
    >
      <template #modal-header="{ close }">
        <div class="w-100 bulk-selection-modal-header-inner">
          <h5 class="modal-title mb-0">Bulk Selection</h5>
          <div class="bulk-selection-modal-header-actions">
            <b-button
              size="sm"
              variant="success"
              class="d-inline-flex align-items-center justify-content-center"
              as="a"
              href="/BulkKothonRechargeUploader.xlsx"
              download
            >
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Download Demo File
            </b-button>
            <button type="button" aria-label="Close" class="close" @click="close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <div class="d-flex align-items-end bulk-selection-upload-row">
        <b-form-group label="Upload Excel File" class="flex-grow-1 mb-0 mr-2">
          <b-form-file
            v-model="bulkSelectionFile"
            accept=".xlsx, .xls"
            placeholder="Choose Excel file..."
            @input="onBulkSelectionFileSelected"
          ></b-form-file>
        </b-form-group>
        <b-button
          variant="info"
          class="flex-shrink-0 d-inline-flex align-items-center mt-2"
          :disabled="!bulkSelectionFile"
          @click="uploadBulkSelection"
        >
          <feather-icon icon="UploadIcon" size="14" class="mr-50" />
          Upload
        </b-button>
      </div>
      <small class="form-text text-muted d-block mb-0">
        Excel should have column: mobile_number
      </small>

      <div
        v-if="bulkSelectionUnmatched.length"
        class="bulk-selection-unmatched alert alert-warning mt-3 mb-0"
      >
        <p class="bulk-selection-unmatched-title mb-2">
          {{ bulkSelectionUnmatched.length }} number(s) not found
        </p>
        <div class="bulk-selection-unmatched-list">
          <span
            v-for="(number, index) in bulkSelectionUnmatched"
            :key="`${number}-${index}`"
            class="bulk-selection-unmatched-chip"
          >
            {{ number }}
          </span>
        </div>
      </div>

      <div v-if="bulkSelectionMatched.length" class="mt-3">
        <b-table
          responsive
          small
          :items="paginatedBulkSelectionMatched"
          :fields="bulkSelectionFields"
          show-empty
          empty-text="No matched numbers"
        >
          <template #cell(sl)="data">
            {{ (bulkSelectionPage - 1) * bulkSelectionPerPage + data.index + 1 }}
          </template>
          <template #cell(balance)="data">
            {{ data.item.balance != null ? data.item.balance : '-' }}
          </template>
          <template #cell(created)="data">
            {{ data.item.created | formatLocalDateTime }}
          </template>
          <template #cell(action)="data">
            <b-button
              size="sm"
              variant="danger"
              class="d-inline-flex align-items-center"
              @click="removeBulkSelectionRow(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" size="14" class="mr-50" />
              Delete
            </b-button>
          </template>
        </b-table>
        <b-row class="mt-2" v-if="bulkSelectionMatched.length > bulkSelectionPerPage">
          <b-col cols="12" class="d-flex justify-content-center">
            <b-pagination
              v-model="bulkSelectionPage"
              :total-rows="bulkSelectionMatched.length"
              :per-page="bulkSelectionPerPage"
              align="center"
              first-number
              last-number
            ></b-pagination>
          </b-col>
        </b-row>

        <div class="bulk-selection-footer-actions mt-3">
          <b-button
            variant="secondary"
            class="d-inline-flex align-items-center justify-content-center"
            @click="closeBulkSelectionModal"
          >
            <feather-icon icon="XIcon" size="14" class="mr-50" />
            Cancel
          </b-button>
          <b-button
            variant="warning"
            class="d-inline-flex align-items-center justify-content-center"
            :disabled="!bulkSelectionMatched.length"
            @click="submitBulkSelectionRecharge"
          >
            <feather-icon icon="ZapIcon" size="14" class="mr-50" />
            Bulk Recharge
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- Balace Modal -->
    <b-modal
      id="kothonBalanceModal"
      :title="'Current Balance'"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-card class="mb-2">
        <table class="table table-bordered responsive">
            <tr>
              <th>Mobile Number</th>
              <td>{{ balanceInfo.mobile_number }}</td>
            </tr>
            <tr>
              <th>Balance</th>
              <td>{{ balanceInfo.balance || 0 }} Tk</td>
            </tr>
         </table>
      </b-card>
      <b-button variant="secondary" class="d-inline-flex align-items-center" @click="$bvModal.hide('kothonBalanceModal')">
        <feather-icon icon="XIcon" size="14" class="mr-50" />
        Close
      </b-button>
    </b-modal>

    <!-- Transaction Modal  -->
    <b-modal
      id="kothonTransactionModal"
      :title="'Transaction'"
      size="xl"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <KothonTransaction :mobileNumber="mobileNumber" />
      <b-button variant="secondary" class="d-inline-flex align-items-center" @click="$bvModal.hide('kothonTransactionModal')">
        <feather-icon icon="XIcon" size="14" class="mr-50" />
        Close
      </b-button>
    </b-modal>

    <!-- Call history Modal -->
    <b-modal
      id="kothonCallHistory"
      :title="'Call History'"
      size="xl"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <kothon-call-history :mobileNumber="mobileNumber" />
      <b-button variant="secondary" class="d-inline-flex align-items-center" @click="$bvModal.hide('kothonCallHistory')">
        <feather-icon icon="XIcon" size="14" class="mr-50" />
        Close
      </b-button>
    </b-modal>

    <!-- Limit Set History Modal -->
    <b-modal
      id="kothonLimitSetHistoryModal"
      :title="'Limit Set History (' + currentMobileNumber + ')'"
      size="xl"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      @hidden="limitSetHistoryLineId = null"
    >
      <line-limit-set-history
        :line-id="limitSetHistoryLineId"
        :customer-id="userData && userData.username"
        customer-id-param="mime_id"
        endpoint="/kothon/api/v1/kothon_line_limit_set_history/"
        :show-source-column="false"
      />
      <b-button
        variant="secondary"
        class="d-inline-flex align-items-center mt-1"
        @click="$bvModal.hide('kothonLimitSetHistoryModal')"
      >
        <feather-icon icon="XIcon" size="14" class="mr-50" />
        Close
      </b-button>
    </b-modal>

    
  </div>
</template>

<script>
import { 
  BCard, BTable, BBadge, BButton, BDropdown, BDropdownItem, 
  BForm, BFormFile, BRow, BCol,     BFormInput,
    BFormSelect,
    BFormGroup, 
  BPagination, BFormCheckbox, BSpinner, BProgress
} from "bootstrap-vue";
import api from "@/services/api";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import * as XLSX from "xlsx";
import KothonTransaction from "./KothonTransaction.vue";
import KothonCallHistory from "./KothonCallHistory.vue";
import LineLimitSetHistory from "./LineLimitSetHistory.vue";
import { required, min_value } from "vee-validate/dist/rules";
import moment from "moment";
import { decrypt } from "@/utils/crypto";
import flatPickr from "vue-flatpickr-component";

extend("required", required);
extend("min_value", min_value);

export default {
  components: {
    BCard,
    BTable,
    BBadge,
    BButton,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormFile,
    BRow,
    BCol,
  BFormInput,
  BFormSelect,
  BFormGroup,
    BPagination,
    BFormCheckbox,
    BSpinner,
    BProgress,
    ValidationProvider,
    ValidationObserver,
    KothonTransaction,
    KothonCallHistory,
    LineLimitSetHistory,
    flatPickr,
  },

  data() {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userData = decrypt(localStorage.getItem("userData"));
    
    return {
      userDetails,
      userData,
      kothonInfo: [],
      balanceInfo: {},
      transactions: [],
      selectedRows: [],
      selectedLinesData: [],
      currentPage: 1,
      mobileNumber: "",
      currentMobileNumber: "",
      limitSetHistoryLineId: null,
      perPage: 10,
      didSearchQuery: "",
      didSearchTimer: null,
      didPage: 1,
      didLimit: 10,
      didLimitOptions: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
        { value: 500, text: '500' },
        { value: -1, text: 'All' },
      ],
      didTotalCount: 0,
      bulkSelectionPage: 1,
      bulkSelectionPerPage: 10,
      paymentData: {
        credit: "",
        selectedKothon: null,
      },
      setLimitData: {
        limit: 0,
      },
      bulkFile: null,
      be_errors: {},
      bulkRechargePreview: [],
      bulkRechargeTotal: 0,
      bulkPreviewPage: 1,
      bulkPreviewLimit: 10,
      bulkPreviewLimitOptions: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ],
      bulkPreviewTotalCount: 0,
      bulkRechargeSubmitting: false,
      bulkRechargeProgressing: false,
      bulkRechargeProgress: 0,
      bulkRechargeJobId: null,
      bulkRechargePollTimer: null,
      bulkRechargeCompletedCount: 0,
      bulkRechargeTotalCount: 0,
      bulkSelectionFile: null,
      bulkSelectionMatched: [],
      bulkSelectionUnmatched: [],
      bulkSelectionFields: [
        { key: "sl", label: "SL", thStyle: { width: "5%" } },
        { key: "mobile_number", label: "Mobile Number" },
        { key: "sip_number", label: "SIP Number" },
        { key: "created", label: "Created" },
        { key: "limit", label: "Limit (Tk)" },
        { key: "balance", label: "Balance (Tk)", thStyle: { width: "10%" } },
        { key: "action", label: "Action", thStyle: { width: "10%" } },
      ],
      downloading: false,
      summaryFilters: {
        from_date: moment().startOf('month').format('YYYY-MM-DD'),
        to_date: moment().format('YYYY-MM-DD'),
      },
      summaryDateConfig: {
        fromDate: {
          altFormat: "d/m/Y",
          altInput: true,
          dateFormat: "Y-m-d",
        },
        toDate: {
          altFormat: "d/m/Y",
          altInput: true,
          dateFormat: "Y-m-d",
          minDate: null,
        },
      },
      videoUrl: "/documents/How_to_Pay_for_MiME_Internet_from_Selfcare.mp4",

      transactionFields: [
        { key: "sl", label: "#" },
        { key: "username", label: "Mobile Number" },
        { key: "cost", label: "Amount (Tk)" },
        { key: "type", label: "Payment Mode" },
        { key: "creationdate", label: "Payment Date" },
      ],

      bulkPreviewFields: [
        { key: "number", label: "Number" },
        { key: "limit", label: "Limit" },
        { key: "last_usage", label: "Last Usage" },
        { key: "amount_to_recharge", label: "Amount To Recharge" },
      ],
    };
  },

  computed: {
      infoFields() {
        if (this.userDetails?.interested_on === 'corporate') {
          return [
            { key: "select", label: "", tdClass: "align-middle" },
            { key: "sl", label: "#", thStyle: { width: "5%" } },
            { key: "mobile_number", label: "Mobile Number" },
            { key: "sip_number", label: "SIP Number" },
            { key: "created", label: "Created" },
            { key: "limit", label: "Limit (Tk)" },
            { key: "balance", label: "Balance (Tk)", thStyle: { width: "10%" } },
            { key: "action", label: "Action", thStyle: { width: "10%" } },
          ];
        }

        return [
          { key: "sl", label: "#", thStyle: { width: "5%" } },
          { key: "mobile_number", label: "Mobile Number" },
          { key: "sip_number", label: "SIP Number" },
          { key: "created", label: "Created" },
          { key: "limit", label: "Limit (Tk)" },
          { key: "balance", label: "Balance (Tk)", thStyle: { width: "10%" } },
          { key: "action", label: "Action", thStyle: { width: "10%" } },
        ];
    },
    isDidShowAll() {
      return Number(this.didLimit) === -1;
    },
    didOffset() {
      if (this.isDidShowAll) return 0;
      return (this.didPage - 1) * Number(this.didLimit);
    },
    totalBalance() {
      if (!this.kothonInfo.length) return 0;
      return this.kothonInfo[0].balance || 0;
    },

    paginatedTransactions() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.transactions.slice(start, end);
    },
    isAllSelected() {
      return this.kothonInfo.every(item => this.selectedRows.includes(item.id));
    },
    paginatedBulkSelectionMatched() {
      const start = (this.bulkSelectionPage - 1) * this.bulkSelectionPerPage;
      const end = start + this.bulkSelectionPerPage;
      return this.bulkSelectionMatched.slice(start, end);
    }
  },

  watch: {
    "summaryFilters.from_date"(newVal) {
      this.summaryDateConfig.toDate.minDate = newVal || null;
      if (
        newVal &&
        this.summaryFilters.to_date &&
        moment(this.summaryFilters.to_date).isBefore(moment(newVal), "day")
      ) {
        this.summaryFilters.to_date = newVal;
      }
    },
  },

  methods: {
    // Check if an item is selected
    isSelected(id) {
      return this.selectedRows.includes(id);
    },

    // Toggle single selection
    toggleSelection(id) {
      if (this.isSelected(id)) {
        this.selectedRows = this.selectedRows.filter(rowId => rowId !== id);
        this.selectedLinesData = this.selectedLinesData.filter(item => item.id !== id);
      } else {
        this.selectedRows.push(id);
        const found = this.kothonInfo.find(item => item.id === id);
        if (found) {
          this.selectedLinesData.push({ id: found.id, limit: parseFloat(found.limit) || 0 });
        }
      }
    },

    // Toggle select all
    toggleSelectAll() {
      if (this.isAllSelected) {
        const currentPageIds = this.kothonInfo.map(item => item.id);
        this.selectedRows = this.selectedRows.filter(id => !currentPageIds.includes(id));
        this.selectedLinesData = this.selectedLinesData.filter(item => !currentPageIds.includes(item.id));
      } else {
        const newSelected = [...this.selectedRows];
        const newData = [...this.selectedLinesData];
        this.kothonInfo.forEach(item => {
          if (!newSelected.includes(item.id)) {
            newSelected.push(item.id);
            newData.push({ id: item.id, limit: parseFloat(item.limit) || 0 });
          }
        });
        this.selectedRows = newSelected;
        this.selectedLinesData = newData;
      }
    },

    onDidSearchInput() {
      clearTimeout(this.didSearchTimer);
      this.didSearchTimer = setTimeout(() => {
        this.didPage = 1;
        this.fetchKothonInfo();
      }, 400);
    },

    onDidLimitChange() {
      this.didLimit = Number(this.didLimit);
      this.didPage = 1;
      this.fetchKothonInfo();
    },

    onDidPageChange() {
      this.fetchKothonInfo();
    },

    getSelectedKothonData() {
      return this.selectedLinesData.filter(item => this.selectedRows.includes(item.id));
    },

    openBulkRechargeModal() {
      if (!this.selectedRows.length) {
        this.$bvToast.toast("Please select at least one Kothon line", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.resetBulkRechargeProgress();
      this.bulkRechargePreview = [];
      this.bulkRechargeTotal = 0;
      this.bulkPreviewPage = 1;
      this.bulkPreviewTotalCount = 0;
      this.$bvModal.show("bulkRechargeModal");
      this.getBulkRechargePreview();
    },

    async getBulkRechargePreview() {
      const loader = this.$showCustomLoader();
      try {
        const payload = {
          mime_id: this.userData?.username,
          action_type: "pre_check",
          lines: this.getSelectedKothonData(),
          limit: this.bulkPreviewLimit,
          offset: (this.bulkPreviewPage - 1) * this.bulkPreviewLimit
        };

        const response = await api.post("/kothon/api/v1/kothon_bulk_recharge/", payload);
        
        if (response.data && response.data.preview) {
          this.bulkRechargePreview = response.data.preview;
          this.bulkRechargeTotal = response.data.total_recharge || 0;

          const apiCount = response.data.count;
          if (apiCount !== undefined && apiCount !== null) {
            this.bulkPreviewTotalCount = apiCount;
          } else {
            this.bulkPreviewTotalCount = response.data.preview.length;
          }
          
          // Show warning if any line has exceeded limit
          const exceededLines = this.bulkRechargePreview.filter(
            item => item.last_usage > item.limit
          );
          if (exceededLines.length) {
            this.$bvToast.toast(
              `${exceededLines.length} line(s) have exceeded their limit`,
              {
                title: "Warning",
                variant: "warning",
                solid: true,
              }
            );
          }
        }
      } catch (error) {
        console.error("Bulk recharge preview failed:", error);
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to load preview",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
        this.$bvModal.hide("bulkRechargeModal");
      } finally {
        loader.hide();
      }
    },

    async submitBulkRecharge() {
      this.bulkRechargeSubmitting = true;
      const loader = this.$showCustomLoader();
      
      try {
        const payload = {
          mime_id: this.userData?.username,
          action_type: "submit_recharge",
          lines: this.getSelectedKothonData()
        };

        const response = await api.post("/kothon/api/v1/kothon_bulk_recharge/", payload);
        const jobId = response.data?.id;

        if (!jobId) {
          throw new Error("No recharge job id returned");
        }

        this.bulkRechargeJobId = jobId;
        this.bulkRechargeProgressing = true;
        this.bulkRechargeProgress = 0;
        this.bulkRechargeCompletedCount = 0;
        this.bulkRechargeTotalCount = this.bulkRechargePreview.length || 0;
        this.startBulkRechargePolling(jobId);
      } catch (error) {
        console.error("Bulk recharge failed:", error);
        this.$bvToast.toast(
          error.response?.data?.message || error.message || "Bulk recharge failed",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.bulkRechargeSubmitting = false;
        loader.hide();
      }
    },

    startBulkRechargePolling(jobId) {
      this.clearBulkRechargePollTimer();
      this.pollBulkRechargeStatus(jobId);
      this.bulkRechargePollTimer = setInterval(() => {
        this.pollBulkRechargeStatus(jobId);
      }, 2000);
    },

    async pollBulkRechargeStatus(jobId) {
      try {
        const response = await api.get(`/kothon/api/v1/kothon_bulk_recharge/${jobId}/`);
        const data = response.data || {};

        this.bulkRechargeProgress = Math.min(
          100,
          Number(data.completion_percentage) || 0
        );
        this.bulkRechargeCompletedCount = data.completed_count || 0;
        this.bulkRechargeTotalCount = data.total_count || this.bulkRechargeTotalCount;

        if (data.status === "completed" || this.bulkRechargeProgress >= 100) {
          this.bulkRechargeProgress = 100;
          this.clearBulkRechargePollTimer();

          this.$bvToast.toast("Bulk recharge completed successfully", {
            title: "Success",
            variant: "success",
            solid: true,
          });

          this.selectedRows = [];
          this.selectedLinesData = [];
          this.bulkRechargeProgressing = false;
          this.closeBulkRechargeModal();
          await this.fetchKothonInfo();
          await this.fetchTransactions();
        }
      } catch (error) {
        console.error("Bulk recharge status poll failed:", error);
        this.clearBulkRechargePollTimer();
        this.bulkRechargeProgressing = false;
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to get recharge progress",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      }
    },

    clearBulkRechargePollTimer() {
      if (this.bulkRechargePollTimer) {
        clearInterval(this.bulkRechargePollTimer);
        this.bulkRechargePollTimer = null;
      }
    },

    resetBulkRechargeProgress() {
      this.clearBulkRechargePollTimer();
      this.bulkRechargeProgressing = false;
      this.bulkRechargeProgress = 0;
      this.bulkRechargeJobId = null;
      this.bulkRechargeCompletedCount = 0;
      this.bulkRechargeTotalCount = 0;
      this.bulkRechargeSubmitting = false;
    },

    closeBulkRechargeModal() {
      if (this.bulkRechargeProgressing) {
        return;
      }
      this.resetBulkRechargeProgress();
      this.$bvModal.hide("bulkRechargeModal");
      this.bulkRechargePreview = [];
      this.bulkRechargeTotal = 0;
    },

    onBulkPreviewLimitChange() {
      this.bulkPreviewPage = 1;
      this.getBulkRechargePreview();
    },

    onBulkPreviewPageChange() {
      this.getBulkRechargePreview();
    },

    openBulkSelectionModal() {
      this.resetBulkSelectionModal();
      this.$bvModal.show("bulkSelectionModal");
    },

    closeBulkSelectionModal() {
      this.$bvModal.hide("bulkSelectionModal");
      this.resetBulkSelectionModal();
    },

    resetBulkSelectionModal() {
      this.bulkSelectionFile = null;
      this.bulkSelectionMatched = [];
      this.bulkSelectionUnmatched = [];
      this.bulkSelectionPage = 1;
    },

    normalizeMobileNumber(mobile) {
      let digits = String(mobile || "")
        .trim()
        .replace(/[\s-]/g, "")
        .replace(/^\+/, "");
      digits = digits.replace(/\D/g, "");
      if (digits.startsWith("880")) {
        digits = digits.slice(3);
      }
      if (digits.length === 10 && digits.startsWith("1")) {
        digits = `0${digits}`;
      }
      return digits;
    },

    onBulkSelectionFileSelected(file) {
      this.bulkSelectionMatched = [];
      this.bulkSelectionUnmatched = [];
      if (!file) {
        this.bulkSelectionFile = null;
      }
    },

    async uploadBulkSelection() {
      if (!this.bulkSelectionFile) return;
      await this.processBulkSelectionFile(this.bulkSelectionFile);
    },

    async processBulkSelectionFile(file) {
      if (!file) {
        this.bulkSelectionMatched = [];
        this.bulkSelectionUnmatched = [];
        return;
      }

      const loader = this.$showCustomLoader();
      try {
        this.bulkSelectionUnmatched = [];
        const excelData = await this.readExcelFile(file);
        const excelNumbers = [
          ...new Set(
            excelData
              .map((row) => String(row.mobile_number || "").trim())
              .filter(Boolean)
          ),
        ];

        if (!excelNumbers.length) {
          this.bulkSelectionMatched = [];
          this.bulkSelectionUnmatched = [];
          this.$bvToast.toast(
            "Invalid Excel data. Please ensure column: mobile_number",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return;
        }

        const res = await api.get(
          `/kothon/api/v1/didnumbers/?mime_id=${this.userData?.username}`
        );
        const allDidNumbers = Array.isArray(res.data) ? res.data : (res.data.results || []);

        const normalizedExcelSet = new Set(
          excelNumbers.map((num) => this.normalizeMobileNumber(num)).filter(Boolean)
        );
        const matched = [];
        const matchedNormalized = new Set();

        allDidNumbers.forEach((item) => {
          const normalizedMobile = this.normalizeMobileNumber(item.mobile_number);
          if (
            normalizedMobile &&
            normalizedExcelSet.has(normalizedMobile) &&
            !matchedNormalized.has(normalizedMobile)
          ) {
            matched.push(item);
            matchedNormalized.add(normalizedMobile);
          }
        });

        this.bulkSelectionMatched = matched;
        this.bulkSelectionUnmatched = excelNumbers.filter((num) => {
          const normalized = this.normalizeMobileNumber(num);
          return normalized && !matchedNormalized.has(normalized);
        });

        const unmatchedCount = this.bulkSelectionUnmatched.length;
        if (!matched.length) {
          this.$bvToast.toast("No mobile numbers matched with your Kothon lines", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
        } else if (unmatchedCount > 0) {
          this.$bvToast.toast(
            `${matched.length} matched, ${unmatchedCount} not found`,
            {
              title: "Info",
              variant: "info",
              solid: true,
            }
          );
        } else {
          this.$bvToast.toast(`${matched.length} mobile number(s) matched`, {
            title: "Success",
            variant: "success",
            solid: true,
          });
        }
      } catch (error) {
        console.error("Bulk selection match failed:", error);
        this.bulkSelectionMatched = [];
        this.bulkSelectionUnmatched = [];
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to process Excel file",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        loader.hide();
      }
    },

    removeBulkSelectionRow(id) {
      this.bulkSelectionMatched = this.bulkSelectionMatched.filter(
        (item) => item.id !== id
      );
    },

    submitBulkSelectionRecharge() {
      if (!this.bulkSelectionMatched.length) {
        this.$bvToast.toast("Please match at least one Kothon line", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.selectedRows = this.bulkSelectionMatched.map((item) => item.id);
      this.selectedLinesData = this.bulkSelectionMatched.map((item) => ({
        id: item.id,
        limit: parseFloat(item.limit) || 0
      }));
      this.closeBulkSelectionModal();
      this.$nextTick(() => {
        this.openBulkRechargeModal();
      });
    },

    openDownloadSummaryModal() {
      if (!this.selectedRows.length) {
        this.$bvToast.toast("Please select at least one Kothon line", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }
      
      this.summaryFilters.from_date = moment().startOf('month').format('YYYY-MM-DD');
      this.summaryFilters.to_date = moment().format('YYYY-MM-DD');
      this.summaryDateConfig.toDate.minDate = this.summaryFilters.from_date;
      this.$bvModal.show("downloadSummaryModal");
    },

    async downloadSummary() {
      const isValid = await this.$refs.summaryRules.validate();
      if (!isValid) return;

      this.downloading = true;
      const loader = this.$showCustomLoader();
      
      try {
        const payload = {
          mime_id: this.userData?.username,
          from_date: this.summaryFilters.from_date,
          to_date: this.summaryFilters.to_date,
          line_ids: this.selectedRows
        };

        const response = await api.post("/kothon/api/v1/kothon_lines_summary/", payload);
        
        if (response.data && response.data.summary) {
          this.exportToExcel(response.data.summary);
          this.$bvToast.toast("Summary downloaded successfully", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.$bvModal.hide("downloadSummaryModal");
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Download summary failed:", error);
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to download summary",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.downloading = false;
        loader.hide();
      }
    },

    exportToExcel(data) {
      const excelData = data.map(item => ({
        'Number': item.mobile_number,
        'Total Calls': item.total_count || 0,
        'Total Duration': (item.duration_sum || 0).toFixed(2),
        'Total Cost': (item.call_cost_sum || 0).toFixed(4)
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      
      // Set column widths
      worksheet['!cols'] = [
        { wch: 15 }, // Mobile Number
        { wch: 12 }, // Total Calls
        { wch: 20 }, // Total Duration
        { wch: 15 }, // Total Cost
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Kothon Summary");
      
      const fileName = `kothon_summary_${this.summaryFilters.from_date}_to_${this.summaryFilters.to_date}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    },

    openBulkModal() {
      this.$bvModal.show("bulkOnboardModal");
    },

    async uploadBulkOnboard() {
      if (!this.bulkFile) return;

      const loader = this.$showCustomLoader();

      try {
        const data = await this.readExcelFile(this.bulkFile);
        const payload = data.map(row => ({
          mobile_number: String(row.mobile_number || "").trim(),
          sip_number: String(row.sip_number || "").trim(),
        })).filter(item => item.mobile_number && item.sip_number);

        if (!payload.length) {
          this.$bvToast.toast("Invalid Excel data. Please ensure columns: mobile_number, sip_number", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
          return;
        }

        const res = await api.post(
          `/kothon/api/v1/bulk_onboard/${this.userData?.username}/`,
          payload
        );

        this.$bvToast.toast("Bulk onboard successful", {
          title: "Success",
          variant: "success",
          solid: true,
        });

        this.$bvModal.hide("bulkOnboardModal");
        this.bulkFile = null;
        await this.fetchKothonInfo();
      } catch (error) {
        console.error(error);
        this.$bvToast.toast(
          error.response?.data?.message || "Upload failed",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        loader.hide();
      }
    },

    readExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          resolve(jsonData);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },

    setKothonDidListFromResponse(data) {
      if (Array.isArray(data)) {
        this.kothonInfo = data;
        this.didTotalCount = data.length;
        return;
      }

      this.kothonInfo = data.results || [];
      this.didTotalCount = data.count != null ? data.count : this.kothonInfo.length;
    },

    async fetchKothonInfo() {
      const loader = this.$showCustomLoader();
      try {
        const baseUrl = `/kothon/api/v1/didnumbers/?mime_id=${this.userData?.username}`;
        const searchPart = this.didSearchQuery.trim()
          ? `&search_string=${encodeURIComponent(this.didSearchQuery.trim())}`
          : "";

        let url;
        if (this.isDidShowAll) {
          url = `${baseUrl}${searchPart}`;
        } else {
          url = `${baseUrl}&limit=${this.didLimit}&offset=${this.didOffset}${searchPart}`;
        }
        const res = await api.get(url);
        this.setKothonDidListFromResponse(res.data);
      } catch (error) {
        console.error("Kothon info fetch failed:", error);
        this.$bvToast.toast("Failed to fetch Kothon information", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        loader?.hide();
      }
    },

    async fetchTransactions() {
      try {
        const res = await api.get(
          `/kothon/api/v1/tringy/transaction/history/?mime_id=${this.userData?.username}`
        );
        this.transactions = res.data.message || [];
      } catch (error) {
        console.error("Transaction fetch failed:", error);
      }
    },

    rechargeNow(kothon) {
      this.paymentData.selectedKothon = kothon;
      this.paymentData.credit = "";
      this.paymentData.mobile_number = kothon.mobile_number;
      this.currentMobileNumber = kothon.mobile_number || '';
      this.$bvModal.show("rechargeModal");
    },

    setLimitMethod (item) {
      this.setLimitData.id = item.id;
      this.setLimitData.limit = item.limit || 0;
      this.currentMobileNumber = item.mobile_number || '';
      this.$bvModal.show("setLimitModal");
    },

    openLimitSetHistory(item) {
      if (!item.id) {
        this.$bvToast.toast("Kothon line not found", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.limitSetHistoryLineId = item.id;
      this.currentMobileNumber = item.mobile_number || '';
      this.$bvModal.show("kothonLimitSetHistoryModal");
    },

    async getBalance(mobileNumber) {
      this.currentMobileNumber = mobileNumber || '';
      const loader = this.$showCustomLoader();
      try {
        const res = await api.get(`/kothon/api/v1/kothon_balance/?mobile_number=${mobileNumber}`);
        loader?.hide();
        this.balanceInfo = res.data || {};
        this.balanceInfo.mobile_number = mobileNumber;
        this.$bvModal.show("kothonBalanceModal");
      } catch (error) {
        console.error("Balance fetch failed:", error);
      } finally {
        loader?.hide();
      }
    },
    setTransactionMethod(data) {
      this.mobileNumber = data.item.mobile_number;
      this.currentMobileNumber = data.item.mobile_number || '';
      this.$bvModal.show("kothonTransactionModal");
    },
    setKothonCallHistory(data) {
      this.mobileNumber = data.item.mobile_number;
      this.currentMobileNumber = data.item.mobile_number || '';
      this.$bvModal.show("kothonCallHistory");
    },

    async submitPayment() {
      const isValid = await this.$refs.formBalanceRules.validate();
      if (!isValid) return;

      const loader = this.$showCustomLoader();

      try {
        const payload = {
          credit: Number(this.paymentData.credit),
          mime_id: this.userData?.username,
          payment_from_bundle_wallet: false,
          mobile_number: this.paymentData.mobile_number,
        };

        const res = await api.post("/kothon/api/v1/tringy/balancetransfer/", payload);

        // Adjust the success check to match the actual response
        if (res.status === 200 || (res.data && res.data.message)) {
          this.$bvToast.toast(res.data.message || "Recharge successful", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          
          // Close the modal and reset form data
          this.$bvModal.hide("rechargeModal");
          this.paymentData.credit = "";
          this.paymentData.selectedKothon = null;
          this.paymentData.mobile_number = null;
          
          // Refresh data
          await this.fetchKothonInfo();
          await this.fetchTransactions();
        } else {
          this.$bvToast.toast(res.data.message || "Payment failed", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } catch (error) {
        console.error("Payment failed", error);
        const apiMessage = error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Payment failed";

        this.$bvToast.toast(apiMessage, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        loader.hide();
      }
    },

    async submitSetLimit() {
      this.$refs.formSetLimitRules.validate().then(async (success) => {
        if (!success) return;
       
        const loader = this.$showCustomLoader();

        try {
          const payload = {
            limit: Number(this.setLimitData.limit),
            id: this.setLimitData.id,
          };

          const res = await api.post(
            "/kothon/api/v1/kothon_line_set_limit/",
            payload
          );

          // ✅ Handle successful response
          if (res?.status === 200 || res?.message?.result === "success") {
            this.$bvToast.toast(res.message?.message || "Limit set successful", {
              title: "Success",
              variant: "success",
              solid: true,
            });
            this.$bvModal.hide("setLimitModal");
            this.fetchKothonInfo();
          } else {
            // Handle API returning status 500 but with message
            this.$bvToast.toast(res.message || "Failed to set limit", {
              title: "Error",
              variant: "danger",
              solid: true,
            });
          }

        } catch (error) {
          console.error("Payment failed", error);

          // ✅ Show exact API error message if available
          const apiMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Payment failed";

          this.$bvToast.toast(apiMessage, {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        } finally {
          loader.hide();
        }
      });
    }
  },

  mounted() {
    this.fetchKothonInfo();
    this.fetchTransactions();
  },

  beforeDestroy() {
    this.clearBulkRechargePollTimer();
    clearTimeout(this.didSearchTimer);
  },
};
</script>
<style scoped>
.table-responsive {
  height: 400px;
  overflow-y: auto; /* scroll if content exceeds */
}

.responsive-video {
  width: 100%;
  height: auto;
  max-width: 100%;
}

/* Bulk Recharge Modal - Exact Design Match */
.bulk-recharge-table {
  margin-bottom: 1rem;
}

.bulk-recharge-table >>> th {
  background-color: #f2f2f2 !important;
  font-weight: 600;
  border: 1px solid #dee2e6;
}

.bulk-recharge-table >>> td {
  border: 1px solid #dee2e6;
  padding: 0.5rem;
}

.total-line {
  text-align: left;
  font-size: 1rem;
  margin: 1rem 0;
  padding: 0 0.5rem;
}

.total-line strong {
  font-weight: 600;
  margin-right: 0.5rem;
}

.confirmation-text {
  margin: 1rem 0;
  padding: 0 0.5rem;
  color: #333;
}

/* Modal shell overrides */
:deep(.bulk-modal-content) {
  border: 0.5px solid #e0ddd5;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
}
 
.bulk-modal-wrapper {
  display: flex;
  flex-direction: column;
  background: #ffffff;
}
 
/* ---------- Header ---------- */
.bm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 1.5rem;
  border-bottom: 0.5px solid #e8e5dc;
}
 
.bm-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
 
.bm-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #E6F1FB;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
 
.bm-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a18;
}
 
.bm-subtitle {
  margin: 0;
  font-size: 12px;
  color: #888780;
}
 
.bm-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  font-size: 18px;
  line-height: 1;
  color: #888780;
  border-radius: 6px;
  transition: background 0.15s;
}
.bm-close-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.bm-close-btn:hover:not(:disabled) {
  background: #f1efe8;
  color: #444441;
}
 
/* ---------- Body ---------- */
.bm-body {
  padding: 1.25rem 1.5rem;
}
 
/* Summary cards */
.bm-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 1.25rem;
}
 
.bm-stat-card {
  background: #f7f5f0;
  border-radius: 8px;
  padding: 0.75rem 1rem;
}
 
.bm-stat-label {
  margin: 0 0 4px;
  font-size: 11px;
  color: #888780;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
 
.bm-stat-value {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #1a1a18;
}
 
/* Table */
.bm-table-wrapper {
  border: 0.5px solid #e8e5dc;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 1.25rem;
}
 
.bm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
 
.bm-table thead tr {
  background: #f7f5f0;
}
 
.bm-table thead th {
  padding: 10px 14px;
  font-weight: 500;
  color: #888780;
  border-bottom: 0.5px solid #e8e5dc;
}
 
.bm-table tbody tr {
  border-bottom: 0.5px solid #f1efe8;
  transition: background 0.1s;
}
 
.bm-table tbody tr:last-child {
  border-bottom: none;
}
 
.bm-table tbody tr:hover {
  background: #fafaf8;
}
 
.bm-table tbody td {
  padding: 10px 14px;
}
 
.bm-table tfoot tr {
  background: #f7f5f0;
  border-top: 0.5px solid #e0ddd5;
}
 
.bm-table tfoot td {
  padding: 10px 14px;
}
 
.bm-mono {
  font-family: 'SFMono-Regular', 'Consolas', 'Liberation Mono', monospace;
  font-size: 12px;
  color: #1a1a18;
}
 
.bm-muted {
  color: #888780;
}
 
.bm-amount {
  font-weight: 500;
  color: #0F6E56;
}
 
.bm-total-label {
  font-weight: 500;
  color: #1a1a18;
}
 
.bm-total-value {
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  color: #1a1a18;
}
 
.text-left  { text-align: left; }
.text-right { text-align: right; }
 
/* Warning banner */
.bm-warning {
  background: #FAEEDA;
  border: 0.5px solid #FAC775;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
 
.bm-warning-icon {
  flex-shrink: 0;
  margin-top: 1px;
}
 
.bm-warning-text {
  margin: 0;
  font-size: 13px;
  color: #92640A;
  line-height: 1.5;
}
 
/* Loading */
.bm-loading {
  text-align: center;
  padding: 2.5rem 0;
}
 
.bm-loading-text {
  margin-top: 0.75rem;
  font-size: 13px;
  color: #888780;
}

/* Progress */
.bm-progress {
  padding: 2rem 0.5rem 1rem;
  text-align: center;
}

.bm-progress-label {
  margin: 0 0 1rem;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.bm-progress-bar {
  max-width: 420px;
  margin: 0 auto;
}

.bm-progress-hint {
  margin: 1rem 0 0;
  font-size: 13px;
  color: #888780;
}
 
/* ---------- Footer ---------- */
.bm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 1rem 1.5rem;
  border-top: 0.5px solid #e8e5dc;
  background: #f7f5f0;
}
 
.bm-btn {
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.15s, background 0.15s;
}
 
.bm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
 
.bm-btn-cancel {
  background: #ffffff;
  border: 0.5px solid #d3d1c7;
  color: #888780;
}
 
.bm-btn-cancel:hover:not(:disabled) {
  background: #f1efe8;
  color: #444441;
}
 
.bm-btn-confirm {
  background: #185FA5;
  border: none;
  color: #ffffff;
}
 
.bm-btn-confirm:hover:not(:disabled) {
  background: #0c447c;
}

/* Modal shell */
:deep(.ds-modal-content) {
  border: 0.5px solid #e0ddd5;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
}
 
.ds-wrapper {
  display: flex;
  flex-direction: column;
  background: #ffffff;
}
 
/* ---------- Header ---------- */
.ds-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 1.5rem;
  border-bottom: 0.5px solid #e8e5dc;
}
 
.ds-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
 
.ds-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #E1F5EE;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
 
.ds-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a18;
}
 
.ds-subtitle {
  margin: 0;
  font-size: 12px;
  color: #888780;
}
 
.ds-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  font-size: 18px;
  line-height: 1;
  color: #888780;
  border-radius: 6px;
  transition: background 0.15s;
}
.ds-close-btn:hover {
  background: #f1efe8;
  color: #444441;
}
 
/* ---------- Body ---------- */
.ds-body {
  padding: 1.25rem 1.5rem;
}
 
/* Date grid */
.ds-date-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 1rem;
}
 
/* Field */
.ds-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
 
.ds-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 500;
  color: #5F5E5A;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
}
 
.ds-input-wrap {
  border: 0.5px solid #d3d1c7;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s;
}
 
.ds-input-wrap:focus-within {
  border-color: #185FA5;
}
 
.ds-input-wrap.ds-input-error {
  border-color: #E24B4A;
  background: #fff8f8;
}
 
.ds-input {
  width: 100%;
  border: none;
  outline: none;
  padding: 9px 12px;
  font-size: 13px;
  color: #1a1a18;
  background: transparent;
  font-family: inherit;
}

.ds-input-wrap ::v-deep .ds-summary-date.form-control,
.ds-input-wrap ::v-deep .flatpickr-input.ds-summary-date {
  width: 100%;
  border: none;
  outline: none;
  padding: 9px 12px;
  font-size: 13px;
  color: #1a1a18;
  background: transparent;
  font-family: inherit;
  box-shadow: none;
  height: auto;
  min-height: 0;
}
 
.ds-error {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #A32D2D;
  margin-top: 2px;
}
 
/* Selected lines badge */
.ds-lines-badge {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #E6F1FB;
  border: 0.5px solid #B5D4F4;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 1rem;
}
 
.ds-lines-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
 
.ds-lines-label {
  font-size: 13px;
  color: #185FA5;
  font-weight: 500;
}
 
.ds-lines-count {
  font-size: 12px;
  font-weight: 500;
  background: #185FA5;
  color: #ffffff;
  padding: 2px 10px;
  border-radius: 20px;
}
 
/* Info strip */
.ds-info {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #f7f5f0;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 1.25rem;
}
 
.ds-info-icon {
  flex-shrink: 0;
  margin-top: 1px;
}
 
.ds-info-text {
  margin: 0;
  font-size: 12px;
  color: #5F5E5A;
  line-height: 1.6;
}
 
/* ---------- Actions ---------- */
.ds-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 0.25rem;
}
 
.ds-btn {
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.15s, background 0.15s;
}
 
.ds-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
 
.ds-btn-cancel {
  background: #ffffff;
  border: 0.5px solid #d3d1c7;
  color: #888780;
}
 
.ds-btn-cancel:hover:not(:disabled) {
  background: #f1efe8;
  color: #444441;
}
 
.ds-btn-download {
  background: #0F6E56;
  border: none;
  color: #ffffff;
}
 
.ds-btn-download:hover:not(:disabled) {
  background: #085041;
}

::v-deep .bulk-selection-modal-header {
  align-items: center;
  padding: 1rem 1.25rem;
}

::v-deep .bulk-selection-modal-header .close {
  margin: 0;
  padding: 0.25rem 0.5rem;
  flex-shrink: 0;
}

/* Page toolbar: Bulk Onboard, Bulk Recharge Selection, etc. */
.kothon-bulk-actions {
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.5rem;
}

.kothon-bulk-action-btn {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
  white-space: nowrap;
  font-weight: 600;
  letter-spacing: 0.01em;
  box-shadow: 0 1px 2px rgba(22, 29, 37, 0.12);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.kothon-bulk-action-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(22, 29, 37, 0.16);
}

@media (max-width: 575.98px) {
  .kothon-bulk-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .kothon-bulk-action-btn {
    width: 100%;
    white-space: normal;
    justify-content: center;
  }
}

@media (min-width: 576px) and (max-width: 991.98px) {
  .kothon-bulk-action-btn {
    flex: 1 1 calc(50% - 0.2rem);
    min-width: 0;
    white-space: normal;
  }
}

/* Bulk Onboard modal actions */
.bulk-onboard-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.25rem;
}

@media (max-width: 575.98px) {
  .bulk-onboard-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-onboard-actions .btn {
    width: 100%;
  }
}

/* Bulk Selection modal */
.bulk-selection-modal-header-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.bulk-selection-modal-header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
}

.bulk-selection-upload-row {
  flex-wrap: wrap;
  gap: 0.5rem;
}

.bulk-selection-upload-row .form-group {
  flex: 1 1 12rem;
  min-width: 0;
  margin-right: 0 !important;
}

.bulk-selection-upload-row > .btn {
  flex: 0 0 auto;
  margin-top: 0 !important;
}

.bulk-selection-unmatched {
  border-radius: 8px;
  padding: 0.75rem 1rem;
}

.bulk-selection-unmatched-title {
  font-size: 13px;
  font-weight: 600;
  color: #856404;
}

.bulk-selection-unmatched-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.bulk-selection-unmatched-chip {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  font-size: 12px;
  font-family: monospace;
  background: #fff8e6;
  border: 1px solid #f0d78c;
  border-radius: 4px;
  color: #664d03;
}

@media (max-width: 575.98px) {
  .bulk-selection-modal-header-inner {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-selection-modal-header-actions {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }

  .bulk-selection-modal-header-actions .btn {
    flex: 1 1 auto;
    min-width: 0;
  }

  .bulk-selection-upload-row {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-selection-upload-row > .btn {
    width: 100%;
  }
}

.bulk-selection-footer-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}

@media (max-width: 575.98px) {
  .bulk-selection-footer-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-selection-footer-actions .btn {
    width: 100%;
  }
}

.did-search-input {
  max-width: 300px;
  border-radius: 8px;
  font-size: 13px;
  padding: 0.35rem 0.75rem;
}

.did-limit-select {
  width: auto;
  min-width: 80px;
  border-radius: 8px;
  font-size: 13px;
  padding: 0.35rem 0.5rem;
}

@media (max-width: 575.98px) {
  .did-search-input {
    max-width: 100%;
  }
}
</style>